import { render, staticRenderFns } from "./ProgramTabTasks.vue?vue&type=template&id=4b64b368&"
import script from "./ProgramTabTasks.vue?vue&type=script&lang=js&"
export * from "./ProgramTabTasks.vue?vue&type=script&lang=js&"
import style0 from "./ProgramTabTasks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports